import React, { useEffect } from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { FormikInput, ButtonTooltip, Icon } from '../../../components';

export const SelectionChoiceRow = ({ valuePath, position, onDelete, disableDelete, inputType }) => {
  const { errors, touched, setFieldValue } = useFormikContext();

  useEffect(() => {
    setFieldValue(`${valuePath}[position]`, position);
  }, [position, valuePath, setFieldValue]);

  return (
    <Row className="align-items-center mb-2">
      <Col xs="auto">
        <Form.Check type={inputType} disabled style={{ marginTop: '8px' }} />
      </Col>
      <Col>
        <Field name={`${valuePath}[label]`}>
          {({ field }) => (
            <FormikInput
              {...field}
              placeholder={`Respuesta ${position}`}
              maxLength={100}
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
            />
          )}
        </Field>
      </Col>
      <Col xs="auto">
        <ButtonTooltip
          variant="circle-danger"
          className="btn-circle"
          size="sm"
          text="Eliminar"
          onClick={onDelete}
          disabled={disableDelete}
        >
          <Icon icon="trash" />
        </ButtonTooltip>
      </Col>
    </Row>
  );
};

export const SelectionChoicesLayout = ({
  valuePath,
  questionChoicesAttributes = [],
  descriptionPlaceholder,
  inputType,
  addChoice,
  deleteChoice
}) => {
  const { errors, touched } = useFormikContext();
  const visibleChoices = questionChoicesAttributes.filter(c => !c._destroy);

  return (
    <div className="mt-3">
      <Row>
        <Col md={10}>
          <Field name={`${valuePath}[label]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Pregunta"
                maxLength={100}
                tooltipText="Máximo 100 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Field name={`${valuePath}[description]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                label="Descripción opcional"
                maxLength={300}
                placeholder={descriptionPlaceholder}
                tooltipText="Máximo 300 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <div className="mt-2">
        {questionChoicesAttributes.map((choice, choiceIndex) => {
          if (choice._destroy) return null;
          const visibleIndex = questionChoicesAttributes.slice(0, choiceIndex).filter(c => !c._destroy).length;
          return (
            <SelectionChoiceRow
              key={choice.id ? `choice-${choice.id}` : `choice-pos-${choice.position}`}
              inputType={inputType}
              valuePath={`${valuePath}[questionChoicesAttributes][${choiceIndex}]`}
              position={visibleIndex + 1}
              onDelete={() => deleteChoice(choiceIndex)}
              disableDelete={visibleChoices.length <= 2}
            />
          );
        })}
      </div>
      <Row className="mt-2">
        <Col className="d-flex justify-content-end">
          <Button variant="primary" size="sm" onClick={addChoice}>
            Agregar Respuesta
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SelectionChoicesLayout;
